export const GTM_ID = "GTM-WV2V6PH";
export const GTM_SCRIPT =
  process.env.APP_ENV === "production"
    ? `window.dataLayer = window.dataLayer || [];(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GTM_ID}');`
    : `window.dataLayer = window.dataLayer || [];(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+ '&gtm_auth=JoJToszBHzWYleFaove3VQ&gtm_preview=env-6&gtm_cookies_win=x';f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GTM_ID}');`;
export const GTM_NOSCRIPT =
  process.env.APP_ENV === "production"
    ? `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`
    : `<iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}&gtm_auth=JoJToszBHzWYleFaove3VQ&gtm_preview=env-6&gtm_cookies_win=x" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;

export const ecommerceEvent = (action, ecommerce, param) => {
  // ecommerce: nullにしないと、itemsなどがresetされずにpushされていく
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event: action,
    ecommerce,
    ...param,
  });
};

export const event = (action, param) => {
  window.dataLayer.push({
    event: action,
    ...param,
  });
};
